"use client"

import { SunMoon } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `SunMoonIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const SunMoonIcon = component(Icon)({ as: SunMoon })
